import { Div, Flex, Text } from "@hopper-ui/components";
import { ReminderIcon } from "@hopper-ui/icons";
import { useSharedTranslation } from "@workleap-ai/shared";
import { useTranslation } from "react-i18next";

export const ConversationHistoryEmptyState = () => {
    const { t } = useTranslation();
    const { tShared } = useSharedTranslation();

    return (
        <Div width="100%">
            <Div
                paddingX="inset-sm"
                paddingBottom="inset-sm"
            >
                <Text
                    fontFamily="overline"
                    fontSize="overline"
                    fontWeight="overline"
                    textTransform="uppercase"
                    color="neutral-weak"
                >
                    {tShared("today")}
                </Text>
            </Div>
            <Flex
                alignItems="center"
                justifyContent="center"
                width="100%"
                UNSAFE_minHeight="8rem"
                borderRadius="rounded-md"
                paddingX="inset-md"
                paddingY="inset-lg"
                style={{ "border": "0.0625rem dashed var(--hop-neutral-border-weak)" }}
            >
                <Div
                    textAlign="center"
                    color="neutral-weak"
                >
                    <ReminderIcon />
                    <Div
                        fontSize="body-sm"
                        marginTop="inline-sm"
                        UNSAFE_lineHeight="1.25rem"
                    >
                        {t("conversationsEmptyState")}
                    </Div>
                </Div>
            </Flex>
        </Div>
    );
};
